/**
 * 基本页面配置
 **/
import React, { PureComponent } from 'react';
import { Popconfirm,Spin } from 'antd';
import Lang from "@components/Lang/Lang";
import RightCollapse from "./RightCollapse/index";
import "./index.less";
import ReactContext from "@store/reactContext";
import {isEmpty} from "@utils/utils";

class PageCommon extends PureComponent {
    static contextType = ReactContext;
    static defaultProps = {
        className: "",
        btnList:[],
        loading:false,
    }
    constructor(props,context) {
        super(props);
        this.state = {
            showTop: false,
            rightCollapse:false,
            wOption:0,
            showOption:false,
        }
    }
    goTop  = ()=> {
        $(document).scrollTop(0);
    }
    changeRightCollapseBack(rightCollapse){
        this.setState({
            rightCollapse: rightCollapse
        })
    }
    setShowTop(flag=false){
        this.setState({
            showTop: flag
        })
    }
    getPosition(rightCollapse){
        const wOption = document.querySelector('.fixedFooterOption')?document.querySelector('.fixedFooterOption').clientWidth/2:0;
        // const w = wMenu + wOption;
        // console.log(wMenu,"wOption",wOption,w)
        this.setState({
            wOption:wOption,
            showOption: true,
        })
    }
    renderOption(__authState,item,inx, btnClick=true){
        const isHasAuth = __authState.find(option=>option==item.auth);
        if(item.auth&&isEmpty(isHasAuth)){
            return null
        }else {
            return (<span key={inx} className={"btnOption"} onClick={()=>{if(item.btnClick&&btnClick)item.btnClick()}}>
                        {item.icon&&<i className={item.icon} />}<span style={{display:'inline-block'}}>{item.btn}</span>
                        </span>)
        }

    }
    isShowTop(){
        this.showTopTimer = setTimeout(()=>{
            const heiLayout = document.querySelector('.ant-layout-content')?document.querySelector('.ant-layout-content').clientHeight:0;
            if(heiLayout>window.innerHeight){
                this.setShowTop(true)
            }
            if(this.props.btnList.length>0)this.getPosition();
        },1000)
    }
    componentDidMount(){
        this.isShowTop()
       if(this.props.onRef)this.props.onRef(this);
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
        if(this.showTopTimer)clearTimeout(this.showTopTimer)
    }
    render() {
        const {showTop, rightCollapse,wOption,showOption} = this.state;
        const { children,className,btnList,loading } = this.props;
        const { context={} } = this;
        const __authState = context.__authState||[];
        const w = document.querySelector('.ant-layout-sider-children')?document.querySelector('.ant-layout-sider-children').clientWidth/2 + wOption:0;
        return ( <Spin spinning={loading}>
            <div className={className}>
            {children}
            {/* 置顶 */}
            {showTop&&<span className={"fix-top color-white"} onClick={()=>this.goTop()}>
                                 <i className="ri-contract-right-line font-18"></i>
                            </span>}
            {/* 底部操作条 */}

            {btnList&&btnList.length>0?<div className={rightCollapse?"fixedFooterOption fixedFooterOptionRight":"fixedFooterOption"}
                                            style={rightCollapse?{}:{visibility:showOption?"visible":"hidden",right: `calc( 50% - ${w}px)`}}>
                {!rightCollapse&&<>
                {btnList.map((item,inx)=>item.needConfirm?<Popconfirm placement="top"
                                                                      key={'confirm_'+inx}
                                                                      title={item.needConfirm}
                                                                      onConfirm={()=>item.btnClick?item.btnClick():null}
                                                                      okText={Lang({id:'queren',default:'确认'})}
                                                                      cancelText={Lang({id:'QuXiao',default:'取消'})} >
                                                                    {this.renderOption(__authState,item,inx,false)}
                                                        </Popconfirm>:this.renderOption(__authState,item,inx))}
                </>}
                <RightCollapse changeBack={(data)=>this.changeRightCollapseBack(data)}/>
            </div>:null}
        </div>
        </Spin>);
    }
}

export default PageCommon;
